import { QuestionnaireQuestion } from './questionnaire-question';
import { Filters } from '../helpers/filters';

export class Questionnaire {
  id: number;
  company_id: number;

  name: string;
  type_s: 'delivery'|'on_site'|'default';
  
  questionnaire_questions: QuestionnaireQuestion[];

  created_at: string;
  updated_at: string;

  static orderQuestions(questionnaire: Questionnaire) {
  	if(!questionnaire.questionnaire_questions)
  		return;

  	questionnaire.questionnaire_questions = Filters.orderAlphabetically(questionnaire.questionnaire_questions, "local_id", true);
  }
}